import throttle from 'lodash.throttle';
import { CommonExtension } from '../../../core/index.js';
import { Selection, NodeSelection, TextSelection, Plugin, PluginKey } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';
import { dropPoint } from 'prosemirror-transform';
import 'prosemirror-commands';
import 'prosemirror-inputrules';
import 'prosemirror-model';
import React, { Component } from 'react';
import { render } from 'react-dom';
import { GapCursor } from '../../../citadel/extensions/gap-cursor-extension/index.js';

var AFTER_INSERT = "after_insert";

/**
 * 统一样式前缀
 */ var CLASSNAME_PREFIX = "ct";

var classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
// 获取浏览器和系统信息
function getSystemInfo() {
    // browser
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browser = navigator.appName;
    var version = "".concat(parseFloat(navigator.appVersion));
    var nameOffset;
    var verOffset;
    var ix;
    var isMobile = nAgt.toLowerCase().indexOf("mobile") !== -1;
    // Opera
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf("Opera")) !== -1) {
        browser = "Opera";
        version = nAgt.substring(verOffset + 6);
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf("Version")) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    }
    // Opera Next
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf("OPR")) !== -1) {
        browser = "Opera";
        version = nAgt.substring(verOffset + 4);
    // Edge
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Edge")) !== -1) {
        browser = "Microsoft Edge";
        version = nAgt.substring(verOffset + 5);
    // MSIE
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("MSIE")) !== -1) {
        browser = "Microsoft Internet Explorer";
        version = nAgt.substring(verOffset + 5);
    // Chrome
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Chrome")) !== -1) {
        browser = "Chrome";
        version = nAgt.substring(verOffset + 7);
    // Safari
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Safari")) !== -1) {
        browser = "Safari";
        version = nAgt.substring(verOffset + 7);
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf("Version")) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    // Firefox
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Firefox")) !== -1) {
        browser = "Firefox";
        version = nAgt.substring(verOffset + 8);
    // MSIE 11+
    } else if (nAgt.indexOf("Trident/") !== -1) {
        browser = "Microsoft Internet Explorer";
        version = nAgt.substring(nAgt.indexOf("rv:") + 3);
    // Other browsers
    } else if (// eslint-disable-next-line no-cond-assign
    (nameOffset = nAgt.lastIndexOf(" ") + 1) < // eslint-disable-next-line no-cond-assign
    (verOffset = nAgt.lastIndexOf("/"))) {
        browser = nAgt.substring(nameOffset, verOffset);
        version = nAgt.substring(verOffset + 1);
        if (browser.toLowerCase() === browser.toUpperCase()) {
            browser = navigator.appName;
        }
    }
    // trim the version string
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(";")) !== -1) {
        version = version.substring(0, ix);
    }
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(" ")) !== -1) {
        version = version.substring(0, ix);
    }
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(")")) !== -1) {
        version = version.substring(0, ix);
    }
    // system
    var os = "unknown";
    var clientStrings = [
        {
            s: "Windows 10",
            r: /(Windows 10.0|Windows NT 10.0)/
        },
        {
            s: "Windows 8.1",
            r: /(Windows 8.1|Windows NT 6.3)/
        },
        {
            s: "Windows 8",
            r: /(Windows 8|Windows NT 6.2)/
        },
        {
            s: "Windows 7",
            r: /(Windows 7|Windows NT 6.1)/
        },
        {
            s: "Windows Vista",
            r: /Windows NT 6.0/
        },
        {
            s: "Windows Server 2003",
            r: /Windows NT 5.2/
        },
        {
            s: "Windows XP",
            r: /(Windows NT 5.1|Windows XP)/
        },
        {
            s: "Windows 2000",
            r: /(Windows NT 5.0|Windows 2000)/
        },
        {
            s: "Windows ME",
            r: /(Win 9x 4.90|Windows ME)/
        },
        {
            s: "Windows 98",
            r: /(Windows 98|Win98)/
        },
        {
            s: "Windows 95",
            r: /(Windows 95|Win95|Windows_95)/
        },
        {
            s: "Windows NT 4.0",
            r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/
        },
        {
            s: "Windows CE",
            r: /Windows CE/
        },
        {
            s: "Windows 3.11",
            r: /Win16/
        },
        {
            s: "Android",
            r: /Android/
        },
        {
            s: "Open BSD",
            r: /OpenBSD/
        },
        {
            s: "Sun OS",
            r: /SunOS/
        },
        {
            s: "Linux",
            r: /(Linux|X11)/
        },
        {
            s: "iOS",
            r: /(iPhone|iPad|iPod)/
        },
        {
            s: "Mac OS X",
            r: /Mac OS X/
        },
        {
            s: "Mac OS",
            r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/
        },
        {
            s: "QNX",
            r: /QNX/
        },
        {
            s: "UNIX",
            r: /UNIX/
        },
        {
            s: "BeOS",
            r: /BeOS/
        },
        {
            s: "OS/2",
            r: /OS\/2/
        },
        {
            s: "Search Bot",
            r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
        }
    ];
    for(var id in clientStrings){
        var cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
            os = cs.s;
            break;
        }
    }
    var osVersion = "unknown";
    if (/Windows (.*)/.test(os)) {
        osVersion = /Windows (.*)/.exec(os)[1];
        os = "Windows";
    }
    switch(os){
        case "Mac OS X":
            if (/Mac OS X ([._\d]+)/.test(nAgt)) {
                osVersion = /Mac OS X ([._\d]+)/.exec(nAgt)[1];
            }
            break;
        case "Android":
            if (/Android ([._\d]+)/.test(nAgt)) {
                osVersion = /Android ([._\d]+)/.exec(nAgt)[1];
            }
            break;
        case "iOS":
            if (/OS (\d+)_(\d+)_?(\d+)?/.test(nVer)) {
                var splits = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
                // eslint-disable-next-line no-bitwise
                osVersion = "".concat(splits[1], ".").concat(splits[2], ".").concat(+splits[3] | 0);
            } else if (/iOS\/(\d+).(\d+).?(\d+)?/.test(nVer)) {
                var splits1 = /iOS\/(\d+).(\d+).?(\d+)?/.exec(nVer);
                // eslint-disable-next-line no-bitwise
                osVersion = "".concat(splits1[1], ".").concat(splits1[2], ".").concat(+splits1[3] | 0);
            }
            break;
    }
    return {
        browser: browser || "unknown",
        browserVersion: version || "unknown",
        os: os || "unknown",
        osVersion: osVersion || "unknown",
        isMobile: isMobile,
        isWindows: ~(os || "unknown").toLowerCase().indexOf("win")
    };
}

/**
 * 是否为表格内的位置
 * @param $pos ResolvedPos
 * @returns boolean
 */ var isInTablePos = function($pos) {
    for(var d = $pos.depth; d > 0; d--){
        // 有 tableRole 属性的就是表格的 schema
        if ($pos.node(d).type.spec.tableRole) return true;
    }
    return false;
};
/**
 * 获取在表格中的真正可插入的节点的位置
 * @param $pos ResolvedPos
 * @returns number
 */ var getInsertPosInTable = function($pos) {
    // 不是表格内的 pos 不处理
    if (!isInTablePos($pos)) return null;
    var selectionRight = Selection.near($pos, 1);
    var selectionLeft = Selection.near($pos, -1);
    // 左右可用选区都没有
    if (!selectionRight && !selectionLeft) return null;
    var insertPos = $pos.pos;
    // 只有一边有选区, 那么就用一边的选区的位置
    if (selectionRight && !selectionLeft) {
        insertPos = selectionRight.from;
    } else if (!selectionRight && selectionLeft) {
        insertPos = selectionLeft.from;
    } else {
        // 选取左右最近的能插入的位置, 右侧优先
        insertPos = $pos.pos - selectionLeft.from < selectionRight.from - $pos.pos ? selectionLeft.from : selectionRight.from;
    }
    return insertPos;
};

var DRAG_BUTTON_SCHEMA_PROPS_NAME = "dragBlock";

var hasButton = function(node) {
    return node && node.type.schema.nodes[node.type.name].spec[DRAG_BUTTON_SCHEMA_PROPS_NAME];
};
var getSelection = function(doc, from, to) {
    return NodeSelection.create(doc, from);
};

var TABLE_SELECTOR = ".".concat(classNamePrefix("table-wrapper"));
/**
 * 递归查找所有父级表格元素
 */ var findAllTables = function(dom) {
    var result = [];
    var closestTable = dom === null || dom === void 0 ? void 0 : dom.closest(TABLE_SELECTOR);
    var count = 0;
    while(closestTable && count < 10){
        result.push(closestTable);
        closestTable = closestTable.parentNode.closest(TABLE_SELECTOR);
        count += 1;
    }
    return result;
};

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css_248z = '.ct-drag-button{z-index:50;position:absolute;text-align:center;line-height:28px;cursor:-webkit-grab;width:30px;height:30px;background:url("data:image/svg+xml,%3Csvg width%3D%228px%22 height%3D%2216px%22 viewBox%3D%220 0 8 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E   %3C!-- Generator%3A Sketch 50 (54983) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E   %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E   %3Cdefs%3E%3C%2Fdefs%3E   %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E       %3Cg id%3D%2210%E3%80%81%E7%BC%96%E8%BE%91%E9%A1%B5-%E6%8F%92%E5%85%A5%E4%BB%A3%E7%A0%81%EF%BC%881024%EF%BC%89%22 transform%3D%22translate(-42.000000%2C -789.000000)%22 fill%3D%22%23B0B0B0%22 fill-rule%3D%22nonzero%22%3E           %3Cg id%3D%22%E7%BC%96%E8%BE%91%E5%8C%BA%22 transform%3D%22translate(0.000000%2C 56.000000)%22%3E               %3Cg id%3D%22Group-9-Copy%22 transform%3D%22translate(34.000000%2C 732.000000)%22%3E                   %3Cg id%3D%22%E6%8B%96%E6%8B%BD%E6%89%8B%E6%9F%84%22 transform%3D%22translate(4.000000%2C 1.000000)%22%3E                       %3Cpath d%3D%22M10.5%2C1.90664419e-16 C11.3284347%2C0 12%2C0.671538462 12%2C1.5 C12%2C2.3284347 11.3284615%2C3 10.5%2C3 C9.6715653%2C3 9%2C2.3284347 9%2C1.5 C9%2C0.671565295 9.67153846%2C1.90664419e-16 10.5%2C1.90664419e-16 Z M10.5%2C6.5 C11.3284347%2C6.5 12%2C7.17153846 12%2C8 C12%2C8.8284347 11.3284615%2C9.5 10.5%2C9.5 C9.6715653%2C9.5 9%2C8.8284347 9%2C8 C9%2C7.1715653 9.67153846%2C6.5 10.5%2C6.5 Z M9%2C14.5 C9%2C13.6715653 9.67153846%2C13 10.5%2C13 C11.3284347%2C13 12%2C13.6715385 12%2C14.5 C12%2C15.3284347 11.3284615%2C16 10.5%2C16 C9.6715653%2C16 9%2C15.3284615 9%2C14.5 Z M5.5%2C1.90664419e-16 C6.3284347%2C0 7%2C0.671538462 7%2C1.5 C7%2C2.3284347 6.32846154%2C3 5.5%2C3 C4.6715653%2C3 4%2C2.32846154 4%2C1.5 C4%2C0.671565295 4.67153846%2C1.90664419e-16 5.5%2C1.90664419e-16 Z M5.5%2C6.5 C6.3284347%2C6.5 7%2C7.17153846 7%2C8 C7%2C8.8284347 6.32846154%2C9.5 5.5%2C9.5 C4.6715653%2C9.5 4%2C8.8284347 4%2C8 C4%2C7.1715653 4.67153846%2C6.5 5.5%2C6.5 Z M5.5%2C13 C5.5%2C13 4.6715653%2C13 5.5%2C13 C6.3284347%2C13 7%2C13.6715385 7%2C14.5 C7%2C15.3284347 6.32846154%2C16 5.5%2C16 C4.6715653%2C16 4%2C15.3284615 4%2C14.5 C4%2C13.6715653 4.67153846%2C13 5.5%2C13 Z%22 id%3D%22%E5%8F%AF%E6%8B%96%E6%8B%BD%22%3E%3C%2Fpath%3E                   %3C%2Fg%3E               %3C%2Fg%3E           %3C%2Fg%3E       %3C%2Fg%3E   %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 50%}';
styleInject(css_248z);

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var BUTTON_WIDTH = 30;
var Button = /*#__PURE__*/ function(Component) {
    _inherits(Button, Component);
    var _super = _createSuper(Button);
    function Button(props) {
        _classCallCheck(this, Button);
        var _this;
        _this = _super.call(this, props);
        _this.tables = [];
        _this.handleScroll = function() {
            var getPosition = _this.props.getPosition;
            _this.setState(getPosition());
        };
        var getPosition = _this.props.getPosition;
        _this.state = getPosition();
        return _this;
    }
    var _proto = Button.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        var dom = this.props.dom;
        this.tables = findAllTables(dom);
        this.tables.forEach(function(table) {
            table.addEventListener("scroll", _this.handleScroll);
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var _this = this;
        this.tables.forEach(function(table) {
            table.removeEventListener("scroll", _this.handleScroll);
        });
    };
    _proto.render = function render() {
        var _this_props = this.props, getPosition = _this_props.getPosition, onDragStart = _this_props.onDragStart, onClick = _this_props.onClick;
        var _getPosition = getPosition(), left = _getPosition.left, top = _getPosition.top;
        return /*#__PURE__*/ React.createElement("div", {
            className: classNamePrefix("drag-button"),
            draggable: true,
            style: {
                left: left - BUTTON_WIDTH,
                top: top
            },
            onDragStart: onDragStart,
            onClick: onClick
        });
    };
    return Button;
}(Component);

function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var os = getSystemInfo().os;
var dragCopyModifier = /MAC/.test(os.toUpperCase()) ? "altKey" : "ctrlKey";
var DragButtonView = /*#__PURE__*/ function() {
    function DragButtonView(editorView) {
        var _this = this;
        _classCallCheck$1(this, DragButtonView);
        this.$popover = null;
        this.editorView = null;
        this.destroy = function() {
            _this.container && _this.container.remove();
        };
        this.update = function(editorView) {
            var selection = editorView.state.selection;
            if (_instanceof(selection, NodeSelection)) {
                if (hasButton(selection.node)) {
                    _this.showButton(editorView, selection);
                    return;
                }
            }
            var isTextSel = _instanceof(selection, TextSelection);
            var isGapCursor = _instanceof(selection, GapCursor);
            if (isTextSel || isGapCursor) {
                var resolvedPos = selection.$from;
                var nodeMaybe = isGapCursor ? resolvedPos.parent : resolvedPos.doc.nodeAt(selection.from);
                if (nodeMaybe && hasButton(nodeMaybe)) {
                    var container = NodeSelection.create(resolvedPos.doc, selection.from);
                    _this.showButton(editorView, container);
                    return;
                }
                for(var d = resolvedPos.depth; d >= 0; d--){
                    if (hasButton(resolvedPos.node(d))) {
                        var container1 = NodeSelection.create(resolvedPos.doc, resolvedPos.before(d));
                        _this.showButton(editorView, container1);
                        return;
                    }
                }
            }
            _this.hideButton();
        };
        this.handleDragStart = function(editorView, from, to) {
            return function(event) {
                var dispatch = editorView.dispatch, state = editorView.state;
                var dragDOM = editorView.nodeDOM(from);
                var selection = getSelection(state.doc, from);
                var slice = selection.content();
                event.dataTransfer.setDragImage(dragDOM, 0, 0);
                editorView.dragging = {
                    slice: slice,
                    move: !event[dragCopyModifier],
                    from: from,
                    to: to
                };
                dispatch(state.tr.setSelection(selection));
            };
        };
        this.handleClick = function(editorView, from, to) {
            return function() {
                var dispatch = editorView.dispatch, state = editorView.state;
                var selection = getSelection(state.doc, from);
                dispatch(state.tr.setSelection(selection));
                editorView.focus();
            };
        };
        this.editorView = editorView;
    }
    var _proto = DragButtonView.prototype;
    _proto.hideButton = function hideButton() {
        this.container && render(null, this.container);
    };
    _proto.showButton = function showButton(editorView, selection) {
        var _this = this;
        var from = selection.from, to = selection.to;
        var dom = editorView.nodeDOM(from);
        var buttonProps = {
            onDragStart: this.handleDragStart(editorView, from, to),
            onClick: this.handleClick(editorView, from, to),
            dom: dom,
            getPosition: function() {
                var nodeDOM = editorView.nodeDOM(from);
                var _this_$editor_getBoundingClientRect = _this.$editor.getBoundingClientRect(), pl = _this_$editor_getBoundingClientRect.left, pt = _this_$editor_getBoundingClientRect.top;
                if (!nodeDOM) {
                    return {
                        left: pl,
                        top: pt
                    };
                }
                var _nodeDOM_getBoundingClientRect = nodeDOM.getBoundingClientRect(), cl = _nodeDOM_getBoundingClientRect.left, ct = _nodeDOM_getBoundingClientRect.top;
                return {
                    left: cl - pl,
                    top: ct - pt
                };
            }
        };
        render(/*#__PURE__*/ React.createElement(Button, _extends({}, buttonProps)), this.container);
    };
    _createClass(DragButtonView, [
        {
            key: "container",
            get: function get() {
                if (!this.$popover) {
                    this.$popover = document.createElement("div");
                    this.$popover.classList.add(classNamePrefix("drag-button-popover"));
                    this.$editor = this.editorView.dom.parentElement;
                    this.$editor.appendChild(this.$popover);
                }
                return this.$popover;
            }
        }
    ]);
    return DragButtonView;
}();

var css_248z$1 = '.ProseMirror-dropcursor-bottom{position:relative}.ProseMirror-dropcursor-bottom:after{background-color:#1c6cdc;bottom:-4px;content:"";height:3px;left:0;position:absolute;right:0;z-index:10}.ProseMirror-dropcursor-top{position:relative}.ProseMirror-dropcursor-top:after{background-color:#1c6cdc;content:"";height:2px;left:0;position:absolute;right:0;top:2px;z-index:10}';
styleInject(css_248z$1);

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _assertThisInitialized$1(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties$1(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass$1(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$1(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf$1(o) {
    _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$1(o);
}
function _inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$1(subClass, superClass);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possibleConstructorReturn$1(self, call) {
    if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$1(self);
}
function _setPrototypeOf$1(o, p) {
    _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$1(o, p);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$1(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$1(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$1(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$1(this, result);
    };
}
var gecko = typeof navigator !== "undefined" && /gecko\/\d/i.test(navigator.userAgent);
var linux = typeof navigator !== "undefined" && /linux/i.test(navigator.platform);
function style(options, side) {
    if (side === "bottom" || side === "top") {
        return "border-".concat(side, ": 2px solid #3789a9; margin-").concat(side, ": 2px");
    }
    var width = options && options.width || 1;
    var color = options && options.color || "black";
    return "border-".concat(side, ": ").concat(width, "px solid ").concat(color, "; margin-").concat(side, ": -").concat(width, "px");
}
/**
 * 根据当前拖动的位置插入占位元素
 */ function pluginStateFor(state, pos, options) {
    var $pos = state.doc.resolve(pos);
    var deco;
    if (!$pos.parent.inlineContent) {
        var before = $pos.nodeBefore;
        var after = $pos.nodeAfter;
        if (before) {
            if (before.type.name === "table_row" || before.type.name === "table") {
                // 表格中在单元格外部不支持拖入
                return null;
            }
            // 在前一个节点的底部插入占位符
            deco = Decoration.node(pos - before.nodeSize, pos, {
                nodeName: "div",
                class: "ProseMirror-dropcursor-bottom"
            });
        } else if (after) {
            // 表格中在单元格外部不支持拖入
            if (after.type.name === "table_row") {
                return null;
            }
            // 在后一个节点的顶部插入占位符
            deco = Decoration.node(pos, pos + after.nodeSize, {
                nodeName: "div",
                class: "ProseMirror-dropcursor-top"
            });
        }
    }
    if (!deco) {
        var node = document.createElement("span");
        node.textContent = "​";
        node.style.cssText = "".concat(style(options, "left"), "; display: inline-block; pointer-events: none");
        deco = Decoration.widget(pos, node);
    }
    deco = DecorationSet.create(state.doc, [
        deco
    ]);
    return {
        pos: pos,
        deco: deco
    };
}
/**
 * 计算当前拖动的位置
 */ function dropPos(slice, $pos) {
    // 表格中拖拽的位置是自定义的
    var insertPosInTable = getInsertPosInTable($pos);
    if (insertPosInTable !== null) return insertPosInTable;
    if (!slice || !slice.content.size) return $pos.pos;
    var content = slice.content;
    for(var i = 0; i < slice.openStart; i++){
        content = content.firstChild.content;
    }
    for(var d = $pos.depth; d >= 0; d--){
        // 判断当前位置相对于当前的节点是偏前还是偏后
        var bias = // eslint-disable-next-line no-nested-ternary
        d === $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        var insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        // 判断是否允许在拖动的位置插入元素
        if ($pos.node(d).canReplace(insertPos, insertPos, content)) {
            // eslint-disable-next-line no-nested-ternary
            return bias === 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
        }
    }
    return $pos.pos;
}
var DropCursorExtension = /*#__PURE__*/ function(CommonExtension) {
    _inherits$1(DropCursorExtension, CommonExtension);
    var _super = _createSuper$1(DropCursorExtension);
    function DropCursorExtension() {
        _classCallCheck$2(this, DropCursorExtension);
        return _super.apply(this, arguments);
    }
    var _proto = DropCursorExtension.prototype;
    _proto.plugin = function plugin(param) {
        var editorEventEmitter = param.editorEventEmitter;
        var _this = this;
        var dispatchMeta = function dispatchMeta(view, data) {
            view.dispatch(view.state.tr.setMeta(dcPlugin, data));
        };
        var scheduleRemoval = function scheduleRemoval(view) {
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                if (dcPlugin.getState(view.state)) {
                    dispatchMeta(view, {
                        type: "remove"
                    });
                }
            }, 1000);
        };
        var timeout = null;
        var dcPlugin = null;
        var onDragOver = throttle(function(view, event) {
            var active = dcPlugin.getState(view.state);
            // 获取当前拖动到文档中的位置
            var pos = view.posAtCoords({
                left: event.clientX,
                top: event.clientY
            });
            if (pos) {
                var target = pos.pos;
                if (view.dragging) {
                    target = dropPos(view.dragging.slice, view.state.doc.resolve(target));
                }
                if (!active || active.pos !== target) {
                    dispatchMeta(view, {
                        type: "set",
                        pos: target
                    });
                }
            }
            scheduleRemoval(view);
            return false;
        }, 50);
        dcPlugin = new Plugin({
            key: new PluginKey(this.name),
            state: {
                init: function init() {
                    return null;
                },
                apply: function(tr, prev, state) {
                    // Firefox on Linux gets really confused an breaks dragging when we
                    // mess with the nodes around the target node during a drag. So
                    // disable this plugin there. See https://bugzilla.mozilla.org/show_bug.cgi?id=1323170
                    if (gecko && linux) return null;
                    // eslint-disable-next-line react/destructuring-assignment
                    var command = tr.getMeta(dcPlugin);
                    if (!command) return prev;
                    if (command.type === "set") {
                        return pluginStateFor(state, command.pos, _this.options);
                    }
                    return null;
                }
            },
            props: {
                handleDOMEvents: {
                    dragover: function dragover(view, event) {
                        return onDragOver(view, event);
                    },
                    dragend: function dragend(view) {
                        // 如果当前 view 存在占位元素，则删除
                        if (dcPlugin.getState(view.state)) {
                            dispatchMeta(view, {
                                type: "remove"
                            });
                        }
                        return false;
                    },
                    drop: function drop(view, e) {
                        var _ref;
                        // 如果当前 view 存在占位元素，则删除
                        if (dcPlugin.getState(view.state)) {
                            dispatchMeta(view, {
                                type: "remove"
                            });
                        }
                        // 特殊处理表格的拖拽，参考自 pm-view 源码 editHandlers.drop 部分
                        if (((_ref = view === null || view === void 0 ? void 0 : view.dragging) === null || _ref === void 0 ? void 0 : _ref.tableSelection) !== undefined) {
                            var state = view.state;
                            var tr = state.tr, doc = state.doc;
                            var $pos = state.selection.$anchor;
                            var deleteTable = false;
                            for(var d = $pos.depth; d > 0; d--){
                                var node = $pos.node(d);
                                if (node.type.spec.tableRole === "table") {
                                    tr.delete($pos.before(d), $pos.after(d));
                                    deleteTable = true;
                                    break;
                                }
                            }
                            if (deleteTable) {
                                var slice = (view === null || view === void 0 ? void 0 : view.dragging) && (view === null || view === void 0 ? void 0 : view.dragging.slice);
                                var eventPos = view.posAtCoords({
                                    left: e.clientX,
                                    top: e.clientY
                                });
                                if (!eventPos || !slice) return true;
                                var $mouse = doc.resolve(eventPos.pos);
                                if (!$mouse) return true;
                                var pos = tr.mapping.map(dropPoint(doc, $mouse.pos, slice));
                                tr.replaceRangeWith(pos, pos, slice.content.firstChild);
                                tr.setSelection(new TextSelection(tr.doc.resolve(pos)));
                                view.dispatch(tr.scrollIntoView());
                            }
                            return true;
                        }
                        if (view.dragging && view.dragging.from !== undefined) {
                            view.dispatch(view.state.tr.setSelection(NodeSelection.create(view.state.doc, view.dragging.from)));
                        }
                        return false;
                    },
                    dragleave: function dragleave(view, event) {
                        // 如果当前 view 存在占位元素，则删除
                        if (event.target === view.dom) {
                            dispatchMeta(view, {
                                type: "remove"
                            });
                        }
                        return false;
                    }
                },
                handleDrop: function(view, event, slice) {
                    var _event_target;
                    var isInTable = !!((_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.closest("table"));
                    if (isInTable) {
                        var _Math;
                        var shouldBrace = [];
                        slice.content.descendants(function(node) {
                            if (typeof node.type.spec.braceWidth === "number") {
                                shouldBrace.push(node.type.spec.braceWidth);
                            }
                        });
                        var braceWidth = (_Math = Math).max.apply(_Math, _toConsumableArray(shouldBrace));
                        if (braceWidth > 0) {
                            setTimeout(function() {
                                // 等到插入完成后下个事件迭代进行表格的扩展
                                editorEventEmitter.emit(AFTER_INSERT, {
                                    braceWidth: braceWidth
                                });
                            });
                        }
                    }
                    return false;
                },
                decorations: function decorations(state) {
                    var active = dcPlugin.getState(state);
                    return active && active.deco;
                }
            },
            view: function(view) {
                return new DragButtonView(view);
            }
        });
        return dcPlugin;
    };
    _createClass$1(DropCursorExtension, [
        {
            key: "name",
            get: function get() {
                return "drop_cursor";
            }
        }
    ]);
    return DropCursorExtension;
}(CommonExtension);

export { DropCursorExtension };
//# sourceMappingURL=index.js.map
